/** Keyed by the platform labels in the smart-resize presets. */
const PLATFORM_ABBREVIATIONS: Record<string, string> = {
  Facebook: 'FB',
  Instagram: 'IG',
  LinkedIn: 'LI',
  Snap: 'SN',
  TikTok: 'TT',
  'X (Twitter)': 'X',
  YouTube: 'YT',
};

const FALLBACK_LENGTH = 2;

/** Unlisted platforms fall back to two letters so a new preset still gets a readable badge. */
export const abbreviatePlatform = (platformLabel: string): string =>
  PLATFORM_ABBREVIATIONS[platformLabel] ?? platformLabel.slice(0, FALLBACK_LENGTH).toUpperCase();
